.root {
  width: 100%;
  max-width: 900px;
  padding: 1rem 0;
  margin: 0 auto;

  &:not(:last-child) {
    border-bottom: 1px solid var(--gray-200);
  }
}

.title {
  margin-bottom: 0.25rem;
  font-weight: var(--font-weight-regular);
}

.source {
  display: inline;

  & > * {
    display: inline;
    font-size: inherit;
    font-weight: var(--font-weight-light);
    color: var(--muted-old);
    transform: none;
  }
}

.header {
  margin-bottom: 0.25rem;
}

.actions {
  display: flex;
  gap: 1rem;
  align-items: baseline;
  font-size: var(--font-size-body-2);
}
